import React from "react";
import { Link } from "react-router-dom";
import heroStyles from "../../styles/HeroSection.module.css";
import { ROUTES } from "../../config/routes";

export default function HeroSection() {
    return (
        <section className={heroStyles.hero}>
            <div className={heroStyles.heroContent}>
                <h1 className={heroStyles.heroTitle}>
                    Ever Wonder How Musicians
                    <span className={heroStyles.heroAccent}> Play By Ear?</span>
                </h1>
                <p className={heroStyles.heroSubtitle}>
                    Hear a song and know exactly what to play. Sing in tune with confidence.
                    Break down any melody into the notes and chords that make it work.
                </p>
                <p className={heroStyles.heroDescription}>
                    Stop feeling stuck when you can't figure out a song. Build the ear training
                    skills that let you identify what you're hearing and recreate it yourself.
                </p>
                <div className={heroStyles.heroButtons}>
                    <Link to={ROUTES.DRILL.INTERVALS} className={heroStyles.primaryButton}>
                        Start Training Your Ear
                    </Link>
                    <a href="#why-ear-training" className={heroStyles.secondaryButton}>
                        Why This Matters
                    </a>
                </div>
            </div>
            <div className={heroStyles.heroVisual}>
                <div className={heroStyles.musicNotes}>
                    <span className={heroStyles.note}>♪</span>
                    <span className={heroStyles.note}>♫</span>
                    <span className={heroStyles.note}>♩</span>
                </div>
            </div>
        </section>
    );
}
